export const QUERY_CATEGORIES = [
    'che',
    'gate',
    'quay',
    'yard',
    'vessel',
    'rail',
    'analytics',
    'reporting',
    'operational',
    'financial',
    'snapshot',
    'support',
    'healthcheck',
    'reconciliation',
    'batch',
    'booking',
    'container',
    'truck',
    'appointment',
    'other',
];

export const getCategoryOptions = () => {
    return QUERY_CATEGORIES.map(cat => ({
        label: cat.charAt(0).toUpperCase() + cat.slice(1),
        value: cat
    }));
};
